export default "__VITE_ASSET__BFcPlRqk__"